var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmptyElementItem cursor-pointer",class:{EmptyElementItem__selected: _vm.isSelected},attrs:{"title":_vm.name},on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"EmptyElementItem__image full-width"}),_c('div',{staticClass:"EmptyElementItem__name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }